import React from 'react';

function NotFoundPage(): React.ReactElement {
 return <h1>NOT FOUND</h1>;
}

export default NotFoundPage;
